'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { type FC, useMemo } from 'react';
import useBreakpoints from '@/hooks/useBreakpoints';
import { Button } from '@/shared/components/Button';
import { Modal } from '@/utils/antd-imports';
import type { Platform } from '../../types/platforms';
interface SuccessSocialVerificationModalProps {
  onClose: () => void;
  open: boolean;
  platform: Platform[];
}
export const SuccessSocialVerificationModal: FC<SuccessSocialVerificationModalProps> = ({
  open,
  onClose,
  platform
}) => {
  const {
    lg,
    tablet
  } = useBreakpoints();
  const t = useTranslations('Settings.MyAccount.Form.SuccessSocialVerificationModal');
  const description = useMemo(() => {
    if (platform.length === 1) {
      return t('Platform', {
        platform: platform[0]
      });
    }
    return t('Platforms', {
      platforms: platform.join(', ')
    });
  }, [platform]);
  const calcWidth = () => {
    if (lg) {
      return '560px';
    }
    if (tablet) {
      return '400px';
    }
    return '288px';
  };
  return <Modal open={open} centered={true} closable={false} onCancel={onClose}
  // destroyOnHidden
  footer={null} width={calcWidth()} className="[&_.ant-modal-content]:!bg-transparent" styles={{
    body: {
      display: 'flex',
      flexDirection: 'column',
      height: 'auto',
      padding: lg ? '32px ' : tablet ? '32px 24px' : '28px 24px',
      minHeight: 'auto',
      background: '#1E1E2A',
      backdropFilter: 'blur(36.85px)',
      borderRadius: '24px'
    }
  }}>
      <button onClick={onClose} className={`absolute ${lg ? 'right-[16px] top-[16px]' : 'right-[12px] top-[12px]'}  flex items-center justify-center rounded-full border border-[#E9ECF033] p-2 transition-colors hover:bg-white/10`}>
        <Image src="/icons/close-default.svg" width={12} height={12} alt="Close" />
      </button>
      <div className=" flex flex-auto flex-col items-center justify-start gap-3 lg:gap-4">
        <Image src="/images/check.png" alt="check" className="h-[64px] w-[64px] tablet:h-[80px] tablet:w-[80px] lg:h-[100px] lg:w-[100px]" width={200} height={200} />
        <div className="flex w-full flex-col items-center gap-5 text-center text-[#E9ECF0] lg:gap-6">
          <h2 className="w-full  text-[20px] font-bold leading-[1.15] tablet:text-[32px] lg:text-[36px]">
            {t('Title')}
          </h2>
          <h4 className="w-full  text-base font-medium text-[#E9ECF0CC] lg:text-[20px] ">{description}</h4>
        </div>
        <div className="align-center mt-4 flex w-full flex-col justify-center gap-4   tablet:mt-5 lg:flex-row">
          <Button variant="white" size="md_a" textClassName="font-semibold  leading-[28px] !text-[17px] lg:!text-[19px]" className="w-full grow md:h-[65px]" onClick={onClose} contentClassName="justify-center w-full ">
            {t('Button')}
          </Button>
        </div>
      </div>
    </Modal>;
};